import React, { useEffect, useRef, useState, useMemo } from "react";
import { Input, Modal, Tooltip, Checkbox, Spin } from "antd";
import "./stepFourNew.css";
import TeamEmailSetupContent from "../../../Management/CommunicationSetup/components/teamEmailSetupContent";
import message from "../../../Management/CommunicationSetup/components/custom_message";
// import { message } from "antd";
import { UR_Owner } from "State";
import { checkAccess } from "../../../Auth";
import { CloseCircleOutlined } from "@ant-design/icons";

const svg_warning = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <rect width="18" height="18" rx="9" fill="#081265" />
      <rect x="8" y="4" width="2" height="7" rx="1" fill="white" />
      <rect
        x="10"
        y="12"
        width="2"
        height="2"
        rx="1"
        transform="rotate(90 10 12)"
        fill="white"
      />
    </svg>
  );
};

const tips = {
  team: "This integration will allow each team member to send from their own address (e.g. jane@zeitro.com)",
  individual: "Only you will use this to send emails.(e.g. jane@gmail.com)",
  notification:
    "This email is used for system notifications, such as two-factor authentication codes, password recovery, reminders, and alerts sent to team members and borrowers.(e.g. support@zeitro.com)",
  integration:
    "Team email: This integration will allow each team member to send from their own address (e.g. jane@zeitro.com)",
};
const svg_tips = (type) => {
  return (
    // <span style={{ marginRight: "8px" }}>
      <Tooltip title={tips[type]} placement="bottom">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 17.75C15.1756 17.75 17.75 15.1756 17.75 12C17.75 8.82436 15.1756 6.25 12 6.25C8.82436 6.25 6.25 8.82436 6.25 12C6.25 15.1756 8.82436 17.75 12 17.75ZM12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19Z"
            fill="#6E6E70"
          />
          <path
            d="M13 9C13 9.55228 12.5523 10 12 10C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8C12.5523 8 13 8.44772 13 9Z"
            fill="#6E6E70"
          />
          <path d="M11.25 11H12.75V16H11.25V11Z" fill="#6E6E70" />
        </svg>
      </Tooltip>
    // </span>
  );
};

const tag_integrated = () => {
  return (
    <div className="integrated" style={{marginLeft: 4}}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="10"
        viewBox="0 0 13 10"
        fill="none"
      >
        <rect
          x="0.989258"
          y="4.29297"
          width="2"
          height="7"
          transform="rotate(-45 0.989258 4.29297)"
          fill="#2E605A"
        />
        <rect
          x="11.5957"
          y="0.757324"
          width="2"
          height="10"
          transform="rotate(45 11.5957 0.757324)"
          fill="#2E605A"
        />
      </svg>
      <span style={{ marginLeft: "0px" }}>Integrated</span>
    </div>
  );
};

const StepFourNew = () => {
  const [loading, setLoading] = useState(false);
  const [hasEmailSetup, setHasEmailSetup] = useState(false);
  const [hasOldEmailSetup, setHasOldEmailSetup] = useState(false);
  const [showIndividualEmail_Edit, setShowIndividualEmail_Edit] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [individualEmail, setIndividualEmail] = useState("");
  const [googleAdminAccount, setGoogleAdminAccount] = useState("");
  const [systemNotificationsEmail, setSystemNotificationsEmail] = useState("noreply@zeitro.com");
  const [isSmsEnabled, setIsSmsEnabled] = useState(false);
  const [isIndividualDefaultSender, setIsIndividualDefaultSender] =
    useState(false);
  const [isTeamDefaultSender, setIsTeamDefaultSender] = useState(false);
  const [defaultEmail, setDefaultEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showDifferentIndividualWarning, setShowDifferentIndividualWarning] =
    useState(false);
  const [showTeamEmailSetupDialog, setShowTeamEmailSetupDialog] =
    useState(false);
  const [personalSiteEmail, setPersonalSiteEmail] = useState("");
  const [showIndividualEmail_Success, setshowIndividualEmail_Success] =
    useState(false);
  const [showNotificationEmailDialog, setShowNotificationEmailDialog] =
    useState(false);
  const [notificationEmailInput, setNotificationEmailInput] = useState("");
  const [notificationErrorMessage, setNotificationErrorMessage] = useState("");
  const [showRemoveEmailConfirm, setShowRemoveEmailConfirm] = useState(false);
  const [removeType, setRemoveType] = useState(null);
  const hasRun = useRef(false);
  const [numFlag, setNumFlag] = useState(0);
  const [isEditDefaultEmail, setIsEditDefaultEmail] = useState(true);

  const [loadingObj, setLoadingObj] = useState({
    individualEmail: false,
    notificationEmail: false,
  });

  // 使用 useMemo 缓存 suffix 组件
  const notificationInputSuffix = useMemo(() => {
    return notificationErrorMessage ? <CloseCircleOutlined /> : null;
  }, [notificationErrorMessage]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const host = window.location.host;
  
  const redirect_uri_str = host.includes('localhost') 
    ? `http://${host}/app/welcome`
    : `https://${host}/app/welcome`;
  const isCodeProcessed = useRef(false);
  const isTypeProcessed = useRef(false);

  const getConfig = () => {
    setLoading(true);
    return fetch("/los/getcommunicationconfig", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("config: ", data);
        // {
        // IndividualEmail: null,
        // TeamEmail: null,
        // SystemNotificationsEmail: null,
        // SMSAlertOn: false,
        // defaultEmail: ''
        // }
        data.IndividualEmail && setIndividualEmail(data.IndividualEmail.Email);
      
        setEmailInput(data.IndividualEmail?.Email || "");

        // todo
        data.TeamEmail && setGoogleAdminAccount(data.TeamEmail.Email);

        data.NotificationEmail &&
          setSystemNotificationsEmail(data.NotificationEmail.Email);

        data.SMSAlertOn && setIsSmsEnabled(data.SMSAlertOn);

        if (data.DefaultEmail === "individual") {
          setIsIndividualDefaultSender(true);
          setIsTeamDefaultSender(false);
          setDefaultEmail("individual");
        } else if (data.DefaultEmail === "team") {
          setIsTeamDefaultSender(true);
          setIsIndividualDefaultSender(false);
          setDefaultEmail("team");
        }
        return data;
      }).finally(() => {
        setLoading(false)
      });
  };

  const handleUrlParams = () => {
    // 重新回到页面
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const type = urlParams.get("type");
    if (type === "notification" && !isTypeProcessed.current) {
      // systemNotificationsEmail
      console.log("systemNotificationsEmail------------------------", type, systemNotificationsEmail);
      (systemNotificationsEmail === "noreply@zeitro.com") &&
        getGrantId2(code, redirect_uri_str + "?type=notification", true);
    } else {
      // individualEmail
      if (code && !isCodeProcessed.current) {
        console.log("individualEmail------------------------", code, individualEmail);
        !individualEmail && getGrantId2(code, redirect_uri_str, false);
      }
    }
  }

  const getGrantId2 = (code, redirect_uri, isNotificationEmail) => {
    fetch(
      "/los/nylas/callback?code=" +
        code +
        "&redirect_uri=" +
        (redirect_uri || redirect_uri_str)+ (isNotificationEmail ? "&isnoreply=true" : ""),
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
        },
      }
    ).then((response) => {
      console.log("getGrantId2 response: ", response);
      if (response.ok && response.status === 200) {
        response.json().then((data) => {
          console.log("auth response", data);
          // const urlParams = new URLSearchParams(window.location.search);
          // const type = urlParams.get("type");
          if(isNotificationEmail){
            isTypeProcessed.current = true;
            data.email && setSystemNotificationsEmail(data.email);
          }else{
            isCodeProcessed.current = true;
            data.email && setIndividualEmail(data.email);
            checkAccess([UR_Owner]) && setshowIndividualEmail_Success(true);

            setTimeout(() => {
              check()
              setshowIndividualEmail_Success(false);
            }, 3000);
          }
        });
      }
      if (response.status === 400) {
        console.log("Invalid code");
        console.log("getGrantId2 error", response);
      }
    });
  };

  const check = async () => {
    // getConfig
    const config = await getConfig();
    if (checkAccess([UR_Owner]) && !config.NotificationEmail?.Email) {
      setShowNotificationEmailDialog(true);
      setIsEditDefaultEmail(true);
      setNotificationEmailInput("noreply@zeitro.com");
    }
  }
  const getAuthUrl = async (emailInput, redirect_uri) => {
    let authUrl = "";
    const response = await fetch("/los/nylas/connect?email=" + emailInput, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
      body: JSON.stringify({
        email: emailInput,
        redirect_uri: redirect_uri || redirect_uri_str, //  "http://localhost:3001/nylas/callback"
      }),
    });
    if (response.ok && response.status === 200) {
      const data = await response.json();
      console.log("auth response success", data);
      authUrl = data.url;
      return authUrl;
    } else {
      console.log("auth response err", response);
      return "";
    }
  };

  const handleNotificationEmailSubmit = async () => {
    if(notificationEmailInput === 'noreply@zeitro.com'){
      // todo 从数据库删除noreply@zeitro.com
      setShowNotificationEmailDialog(false);
      setHasEmailSetup(true);
      return;
    }
    if (!notificationEmailInput) {
      setNotificationErrorMessage("Please enter an email address");
      return;
    }

    if (!validateEmail(notificationEmailInput)) {
      setNotificationErrorMessage("Please enter a valid email address");
      return;
    }

    setLoadingObj({...loadingObj, notificationEmail: true});
    // authentication

    const authUrl = await getAuthUrl(
      notificationEmailInput,
      redirect_uri_str + "?type=notification"
    );
    console.log("authUrl--------", authUrl);
    // window.open(authUrl, "_blank");
    window.location.href = authUrl;
  };

  const handleIndividualEmailSubmit = async () => {
    if (!emailInput) {
      setErrorMessage("Please enter an email address");
      return;
    }

    if (!validateEmail(emailInput)) {
      setErrorMessage("Please enter a valid email address");
      return;
    }

    // if (!differentIndividualEmail()) {
      // setShowDifferentIndividualWarning(true);
      // if (numFlag < 1) {
      //   return;
      // }
    // }

    setLoadingObj({...loadingObj, individualEmail: true});

    console.log("Setting up individual email:", emailInput);

    const authUrl = await getAuthUrl(emailInput);
    console.log("authUrl--------", authUrl);

    if (authUrl) {
      setNumFlag(0);
      // window.open(authUrl,"_blank");
      window.location.href = authUrl;
    }
    // setEmailInput("");
    // setErrorMessage("");
  };

  const differentIndividualEmail = () => {
    console.log("differentIndividualEmail", emailInput, personalSiteEmail);
    // 当前填写的email是否和personal site的email不同
    if(emailInput !== personalSiteEmail) {
      setNumFlag(prev => prev + 1);
    }
    return emailInput === personalSiteEmail;
  };

  const getPersonalSiteEmail = () => {
    let token = sessionStorage.getItem("ZeitroA");
    fetch("/los/getprofilesetup", {
      cache: "no-cache",
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Cache: "no-cache",
      },
    }).then((response) => {
      if (!response.ok) {
        console.log(response);
      } else {
        response.json().then((js) => {
          // console.log(js);
          setPersonalSiteEmail(js.Email);
        });
      }
    });
  };

  const removeIndividualEmail = () => {
    fetch("/los/removeindividualemailgrant", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    }).then((response) => {
      console.log(response);
      if (response.ok && response.status === 200) {
        message.success("Individual email removed successfully");
        setIndividualEmail("");
        setEmailInput("");
        setHasEmailSetup(false);
        // handleDefaultSender(false, individualEmail, "individual");
      }
    });
  };
  const removeNotificationEmail = () => {
    fetch("/los/removenotificationemailgrant", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    }).then((response) => {
      console.log(response);
      if (response.ok && response.status === 200) {
        message.success("Notification email removed successfully");
        setSystemNotificationsEmail("noreply@zeitro.com");
        if(!individualEmail){
          setHasEmailSetup(false);
        }
        setIsEditDefaultEmail(true);
      }
    });
  };

  const handleRemoveEmail = (type) => {
    if (type === "individual") {
      setShowRemoveEmailConfirm(true);
      setRemoveType("individual");
    } else if (type === "system") {
      setShowRemoveEmailConfirm(true);
      setRemoveType("system");
    } else if (type === "team") {
      setGoogleAdminAccount("");
    }
  };

  const handleDefaultSender = (checked, email, type) => {
    console.log("handleDefaultSender", checked, email, type);
    fetch("/los/setdefaultemailgrant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
      body: JSON.stringify({
        for: checked ? type : type === "individual" ? "team" : "individual",
      }),
    }).then((response) => {
      console.log(response);
      if (response.ok && response.status === 200) {
        message.success("Default sender set successfully");
        if (type === "team") {
          setIsTeamDefaultSender(checked);
        } else if (type === "individual") {
          setIsIndividualDefaultSender(checked);
        }
        getConfig();
      } else {
        console.log("Failed to set default sender");
      }
    });
  };

  const handleNotificationEmailDialogOpen = () => {
    setNotificationEmailInput(systemNotificationsEmail || 'noreply@zeitro.com');
    if(systemNotificationsEmail === 'noreply@zeitro.com'){
      setIsEditDefaultEmail(true);
    }
    setShowNotificationEmailDialog(true);
    // todo show notification email content
  };

  const getOldConfig = () => {
    fetch("/los/getemailconfigs", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${sessionStorage.getItem("ZeitroA")}`,
      },
    })
    .then((res) => res.json())
    .then((data) => {
      // console.log("old config: ", data);
      if(data.KeysPresent || data.OutlookCredentialsPresent){
        setHasOldEmailSetup(true);
      }
    })
  }

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;
    console.log('------------useEffect- stepFourNew-----------')
    // console.log("useEffect----------", isCodeProcessed.current, isTypeProcessed.current);
    // getConfig
    getConfig();
    getOldConfig();
    getPersonalSiteEmail();
  }, []);

  useEffect(() => {
    if(hasOldEmailSetup){
      setHasEmailSetup(true);
    }
  }, [hasOldEmailSetup])

  useEffect(() => {
    // console.log("individualEmail changed:", individualEmail);
    // 只在 individualEmail 为空时调用 handleUrlParams
    if (!individualEmail) {
      handleUrlParams();
    }
  }, [individualEmail]);

  useEffect(() => {
    if (
      individualEmail ||
      googleAdminAccount ||
      // microsoftAdminAccount ||
      systemNotificationsEmail
    ) {
      if(individualEmail){
        setHasEmailSetup(true);
      }else{
        systemNotificationsEmail !== "noreply@zeitro.com" && setHasEmailSetup(true);
      }
    }
  }, [
    individualEmail,
    googleAdminAccount,
    // microsoftAdminAccount,
    systemNotificationsEmail,
  ]);

  return (
    <div className="step-four-new">
      <div className="ModalTitle">{showNotificationEmailDialog ? 'Notification email setup' : (hasEmailSetup && !loading ? 'Email integration' : 'Individual email' )}</div>
      <div className="description">
        By default, emails are sent from a Zeitro-branded address. Improve email
        credibility by connecting your own domain or custom sender address. You
        can also add later in{" "}
        <span className="boldText">Management {">"} Communication. </span>
      </div>
      {loading && (
        <div className="CommunicationSetupNew-individual-email-loading">
          <Spin />
        </div>
      )}
      {!loading && (
        <>
          {!individualEmail && (!hasOldEmailSetup || showIndividualEmail_Edit) && (
            <div className="CommunicationSetupNew-individual-email">
              <div className="modal-content" style={{ borderBottom: "none" }}>
            <div style={{ marginBottom: "0px" }} className="modal-content-address-title">Your email address</div>
            <div style={{ marginTop: "8px", display: "flex", padding: "0px 0px 10px 0px", gap: "10px" }}>
              <Input
                allowClear={true}
                placeholder="Example: name@gmail.com"
                status={errorMessage ? "error" : ""}
                // suffix={errorMessage ? <CloseCircleOutlined /> : null}
                value={emailInput}
                onChange={(e) => {
                  setEmailInput(e.target.value);
                  setErrorMessage("");
                  if(e.target.value && !personalSiteEmail.startsWith(e.target.value)){
                    setShowDifferentIndividualWarning(true);
                  }else{
                    setShowDifferentIndividualWarning(false);
                  }
                }}
              />
              {/* connect */}
              <div
                className={`connect-btn cursor-pointer ${loadingObj.individualEmail ? "connect-btn-loading" : ""}`}
                id="connect"
                onClick={() => {
                  handleIndividualEmailSubmit();
                }}
              >
                Connect {loadingObj.individualEmail && <Spin/>}
              </div>
            </div>
            {showDifferentIndividualWarning && (
              <div className="modal-content-individual-email-warning">
                {<div style={{ width: "18px", height: "18px", display: "flex" }}>{svg_warning()}</div>}
                <div className="modal-content-individual-email-warning-description">
                  <span>
                    This email is{" "}
                    <span className="modal-content-individual-email-warning-description-bold">
                      different from
                    </span>{" "}
                    the one you use on your Personal site ({personalSiteEmail}).
                  </span>
                  <span>
                    For consistency, we recommend using the same email.
                  </span>
                </div>
              </div>
            )}
            {errorMessage && (
              <div style={{ color: "red", marginTop: "0px" }}>
                {errorMessage}
              </div>
            )}
            {/* integretion team email */}
            {checkAccess([UR_Owner]) && (
              <div className="integration-team-box">
                <div className="text" style={{marginRight: 4}}>Authorize company email</div>
                {/* {svg_tips("integration")} */}
                <div
                className="start cursor-pointer"
                onClick={() => setShowTeamEmailSetupDialog(true)}
              >
                Integrate team email
                </div>
                {svg_tips("integration")}
              </div>
            )}
          </div>
        </div>
      )}
      {showIndividualEmail_Success && (
        <div className="modal-content-individual-email-success">
          <div className="modal-content-individual-email-success-icon">
            <svg
              width="100"
              height="72"
              viewBox="0 0 100 72"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M80.305 60.8765H6.86691C3.13107 60.8765 0.103027 57.8478 0.103027 54.1126V6.76388C0.103027 3.02805 3.13169 0 6.86691 0H80.3053C84.0411 0 87.0692 3.02866 87.0692 6.76388V54.1123C87.0689 57.8478 84.0405 60.8765 80.305 60.8765Z"
                fill="#DFE4F3"
              />
              <path
                d="M80.3048 0H43.6738V60.8762H80.3048C84.0407 60.8762 87.0687 57.8475 87.0687 54.1123V6.76388C87.0687 3.02866 84.0404 0 80.3048 0Z"
                fill="#C3CCEA"
              />
              <path
                d="M43.586 34.7865L87.0689 8.69677V6.76388C87.0689 3.02805 84.0402 0 80.305 0H6.86691C3.13169 0 0.103027 3.02866 0.103027 6.76388V8.69677L43.586 34.7865Z"
                fill="#C3CCEA"
              />
              <path
                d="M87.0687 6.76388C87.0687 3.02866 84.04 0 80.3048 0H43.6738V34.7339L87.0687 8.69677V6.76388Z"
                fill="#8895BC"
              />
              <rect
                x="61.1538"
                y="33.2642"
                width="38.7434"
                height="38.7434"
                rx="19.3717"
                fill="#454E92"
              />
              <path
                d="M89.2506 43.9115C91.6597 46.3208 91.6597 50.227 89.2506 52.6364L87.6822 54.2048C87.3438 54.5433 87.3438 55.092 87.6822 55.4304L88.2016 55.9498C88.54 56.2882 89.0887 56.2882 89.4271 55.9498L90.9955 54.3813C94.3683 51.0084 94.3683 45.5396 90.9955 42.1665C87.6226 38.7935 82.1541 38.7935 78.7811 42.1665L77.2128 43.7349C76.8744 44.0734 76.8744 44.6221 77.2128 44.9605L77.7322 45.4799C78.0706 45.8184 78.6193 45.8184 78.9577 45.4799L80.5261 43.9115C82.9352 41.5022 86.8414 41.5022 89.2506 43.9115Z"
                fill="white"
              />
              <path
                d="M71.8004 61.3605C74.2097 63.7699 78.1158 63.7699 80.5249 61.3605L82.0933 59.7921C82.4317 59.4536 82.9805 59.4536 83.3189 59.7921L83.8382 60.3114C84.1766 60.65 84.1766 61.1986 83.8382 61.537L82.2698 63.1055C78.897 66.4786 73.4284 66.4786 70.0555 63.1055C66.6827 59.7324 66.6827 54.2637 70.0555 50.8906L71.6239 49.3222C71.9623 48.9838 72.511 48.9838 72.8494 49.3222L73.3688 49.8416C73.7072 50.18 73.7072 50.7288 73.3688 51.0672L71.8004 52.6357C69.3912 55.0449 69.3912 58.9512 71.8004 61.3605Z"
                fill="white"
              />
              <path
                d="M84.7059 48.0902C84.3251 47.7095 83.7079 47.7095 83.3271 48.0902L75.9813 55.4364C75.6006 55.8172 75.6006 56.4344 75.9813 56.8152L76.3475 57.1813C76.7282 57.5621 77.3456 57.5621 77.7262 57.1813L85.072 49.8353C85.4527 49.4545 85.4527 48.8371 85.072 48.4564L84.7059 48.0902Z"
                fill="white"
              />
            </svg>
          </div>
          <div className="modal-description">
            ✅ Individual email setup complete
          </div>
          <div className="modal-content">
            <div className="modal-content-individual-email-success-description">
              You'll now send emails from your own connected email — keeping
              communication more personal and traceable.
            </div>
          </div>
        </div>
      )}
      {(individualEmail || hasOldEmailSetup) && !showIndividualEmail_Success && !showNotificationEmailDialog && !showIndividualEmail_Edit &&(
        <div className="CommunicationSetupNew-card">
          {/* divider */}
          {/* {hasEmailSetup && individualEmail && (
            <div className="CommunicationSetupNew-card-divider"></div>
          )} */}
          {/* individual email */}
          {hasEmailSetup && individualEmail && (
            <div className="CommunicationSetupNew-card-team-email-individual">
              <div className="title-box">
                <div className="title" style={{display: "flex", alignItems: "center"}}>
                  Individual email
                  {svg_tips("individual")}
                  {tag_integrated()}
                </div>
                <div className="btn-box">
                  <div
                    className="edit cursor-pointer"
                    onClick={() => {
                      setIndividualEmail("")
                      setShowIndividualEmail_Edit(true)
                    }}
                  >
                    Edit
                  </div>
                  <div
                    className="remove cursor-pointer"
                    onClick={() => handleRemoveEmail("individual")}
                  >
                    Remove
                  </div>
                </div>
              </div>
              <div className="value-box-individual">
                <div className="value">{individualEmail || "Not set"}</div>
                {/* {defaultEmail === "individual" && (
                  <span className="text">Default sender in use</span>
                )}
                {defaultEmail !== "individual" && (
                  <div>
                    <Checkbox
                      checked={isIndividualDefaultSender}
                      onChange={(e) =>
                        handleDefaultSender(
                          e.target.checked,
                          individualEmail,
                          "individual"
                        )
                      }
                    />
                    <span className="checkbox-text">
                      Set as my default sender
                    </span>
                  </div>
                )} */}
              </div>
            </div>
          )}
          {/* not have individual email */}
          {!individualEmail && hasOldEmailSetup  && (
            <div className="CommunicationSetupNew-card-team-email-not-have-individual-email" style={{display: "flex", alignItems: "center", marginBottom: 24}}>
              <span>Want to use your own email</span> 
              <span
                className="CommunicationSetupNew-card-team-email-not-have-individual-email-link cursor-pointer"
                onClick={() => {
                  // handleEmailDialogOpen("individual")
                  setShowIndividualEmail_Edit(true)
                  console.log("integrate individual email")
                }}
              >
                Integrate individual email
              </span>
              {svg_tips("individual")}
            </div>
          )}
          {/* divider */}
          {hasEmailSetup && systemNotificationsEmail && (
            <div className="CommunicationSetupNew-card-divider"></div>
          )}
          {/* System notifications email */}
          {hasEmailSetup && systemNotificationsEmail && (
            <div className="CommunicationSetupNew-card-team-email-system-notifications">
              <div className="title-box">
                <div className="title" style={{display: "flex", alignItems: "center"}}>
                  System notifications email
                  {svg_tips("notification")}
                  {
                  // systemNotificationsEmail !== "noreply@zeitro.com" && 
                  tag_integrated()}
                </div>
                {checkAccess([UR_Owner]) && <div className="btn-box">
                    <div
                      className="edit cursor-pointer"
                      onClick={() => handleNotificationEmailDialogOpen()}
                    >
                      Edit
                    </div>
                    {systemNotificationsEmail !== "noreply@zeitro.com" && <div
                    className="remove cursor-pointer"
                    onClick={() => handleRemoveEmail("system")}
                    >
                      Remove
                    </div>}
                  </div>}
              </div>
              <div>
                <div className="value-box-notifications">
                  <div className="value">{systemNotificationsEmail}</div>
                </div>
              </div>
            </div>
          )}
          {/* divider */}
          {checkAccess([UR_Owner]) && hasEmailSetup && !googleAdminAccount && (
            <div className="CommunicationSetupNew-card-divider"></div>
          )}
          {/* not have team email */}
          {checkAccess([UR_Owner]) && hasEmailSetup && !googleAdminAccount && (
            !hasOldEmailSetup ? <div className="CommunicationSetupNew-card-team-email-not-have-team-email">
              Authorize company email 
              <span
                className="CommunicationSetupNew-card-team-email-not-have-team-email-link cursor-pointer"
                onClick={() => setShowTeamEmailSetupDialog(true)}
              >
                Integrate team email 
                {/* &nbsp; */}
              </span>
              {/* for your team. */}
              {svg_tips("team")}
            </div>
            :
            <div className="CommunicationSetupNew-card-team-email-individual" style={{display: "flex", alignItems: "center"}}>
              <div className="title-box">
                <div className="title" style={{display: "flex", alignItems: "center"}}>
                  <span>Team email</span> {svg_tips("team")} {tag_integrated()}
                </div>
              </div>
              <div className="btn-box">
                <div
                    className="edit cursor-pointer"
                    onClick={async () => {
                      await getOldConfig();
                      setShowTeamEmailSetupDialog(true)
                    }}
                  >
                    Edit
                  </div>
              </div>
            </div>
          )}
        </div>
      )}
      {/* notification email content */}
      {showNotificationEmailDialog && (
        <div
        className="notification-email-modal-content"
        style={{ borderBottom: "none" }}
      >
        <div style={{ marginBottom: "0px" }} className="modal-content-address-title">
          Use the default email or enter your own for system notifications
        </div>
        {systemNotificationsEmail === 'noreply@zeitro.com' && isEditDefaultEmail
        ? 
        <div className="notification-email-content-default-email-box">
          <div style={{display: "flex", alignItems: "center"}}>
            <span className="notification-email-content-default-email">{systemNotificationsEmail} &nbsp;</span>
            <span className="notification-email-content-default-email-text">(Default)</span>
          </div>
          <div className="notification-email-content-default-email-edit-btn cursor-pointer" onClick={() => setIsEditDefaultEmail(false)}>
            Edit
          </div>
        </div>
        :
        <Input
          style={{marginBottom: notificationErrorMessage ? "0px" : "8px"}}
          allowClear={true}
          status={notificationErrorMessage ? "error" : ""}
          // suffix={notificationInputSuffix}
          placeholder="Example: name@gmail.com"
          value={notificationEmailInput}
          onChange={(e) => {
            setNotificationErrorMessage("");
            setNotificationEmailInput(e.target.value);
          }}
          onClear={() => {
            console.log("onClear");
            setNotificationErrorMessage("");
            setNotificationEmailInput("");
          }}
        />}
        {notificationErrorMessage && (
          <div style={{ color: "red", marginTop: "8px", marginBottom: "10px" }}>
            {notificationErrorMessage}
          </div>
        )}
        {/* tool tip */}
        <div className="tool-tip-box">
          This email is used for system notifications, such as two-factor
          authentication codes, password recovery, reminders, and alerts sent
          to team members and borrowers.
        </div>
        {/* footer */}
        <div
            style={{ marginTop: "28px", width: loadingObj.notificationEmail ? "130px" : "111px" }}
            className={`modal-footer-button-${
              notificationEmailInput
                ? ("connect cursor-pointer" + (loadingObj.notificationEmail ? " connect-btn-loading" : ""))
                : "connect-disabled"
            }`}
            onClick={() => {
              handleNotificationEmailSubmit();
            }}
          >
            Finish {loadingObj.notificationEmail && <Spin/>}
          </div>
      </div>
      )}
      </>
      )}
      {/* Remove email confirmation dialog */}
      <Modal
        open={showRemoveEmailConfirm}
        width={410}
        footer={null}
        onCancel={() => setShowRemoveEmailConfirm(false)}
        className="remove-notification-email-confirm-dialog"
      >
        <div className="remove-notification-email-confirm-content">
          <div className="remove-notification-email-confirm-title">
            {removeType === "system" ? "Remove email" : "Remove email"}
          </div>
          <div className="remove-notification-email-confirm-content-text">
            <div style={{marginBottom: "10px"}}>Removing this email will disconnect it from your account. Emails will be sent from the default Zeitro-branded address instead.</div>
            <div>You can re-integrate an email anytime from the Communication Integration settings.</div>
          </div>
          <div className="remove-notification-email-confirm-buttons">
            <div
              className="remove-notification-email-confirm-remove cursor-pointer"
              onClick={() => {
                if (removeType === "individual") {
                  removeIndividualEmail();
                } else if (removeType === "system") {
                  removeNotificationEmail();
                }
                setShowRemoveEmailConfirm(false);
              }}
            >
              Remove
            </div>
            <div
              className="remove-notification-email-confirm-cancel cursor-pointer"
              onClick={() => setShowRemoveEmailConfirm(false)}
            >
              Cancel
            </div>
          </div>
        </div>
      </Modal>
      {/* team email setup dialog */}
      <Modal
        open={showTeamEmailSetupDialog}
        width={942}
        centered
        style={{ overflow: "hidden" }}
        footer={null}
        destroyOnClose
        onCancel={() => setShowTeamEmailSetupDialog(false)}
        className="CommunicationSetupNew-team-email-setup-dialog"
      >
        <div className="CommunicationSetupNew-team-email-setup-dialog-title">
          Team email setup
        </div>
        <div className="CommunicationSetupNew-team-email-setup-dialog-content">
          <TeamEmailSetupContent onClose={() => setShowTeamEmailSetupDialog(false)}></TeamEmailSetupContent>
        </div>
        {/* <div className="CommunicationSetupNew-team-email-setup-dialog-footer">
          <div className="footer-text">
            Once you have your Google workspace account ready, you can contact
            us.
          </div> */}
          {/* <div
            className="footer-button-contact cursor-pointer"
            onClick={() => {
              window.open("mailto:support@zeitro.com");
              setShowTeamEmailSetupDialog(false);
            }}
          >
            Contact us
          </div> */}
        {/* </div> */}
      </Modal>
    </div>
  );
};

export default React.memo(StepFourNew);
